export const COLLATERAL_BAR_NAME = 'hpe-sticky-bar';
const PROPERTY_NAME = '--collateral-sticky-bar-height';
const ADDITIONAL_OFFSET = 3;

export function getStickyBarHeight(): number {
  const $bar = document.querySelector(COLLATERAL_BAR_NAME);
  if (!$bar) return 0;
  const height = getComputedStyle($bar).getPropertyValue(PROPERTY_NAME);
  return (parseInt(height) || 0) + ADDITIONAL_OFFSET;
}

